import QRCode from 'qrcode';

// ===================================
// EVENTS
$(document).on('click', '.qrButton, .overlay, .closeQR', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $('.qrButton').toggleClass('active');
  $('.qrContainer').toggleClass('active');

  if ($('.qrContainer').hasClass('active')) {
    setMapQR();
  }
});

// ==================================
// FUNCTIONS
const setMapQR = async () => {
  const qrMapCode = $('.qrMapCode');
  const qrMapImage = $('.qrMapImage');
  const qrMapTitle = $('.qrMapTitle');
  qrMapCode.removeAttr('src');
  qrMapImage.css('background', 'transparent');
  qrMapTitle.html('');

  try {
    let currentUrl = `${AS.mapQRDomain}${window.historyObj.getUrlData().url}`;
    // remove query params
    currentUrl = currentUrl.split('?')[0];
    if (window.AS.mapSpecialContents && window.AS.mapSpecialContents.length) {
      currentUrl += `?qr=${window.AS.mapSpecialContents[0]}`;
    }
    console.log(`QR - ${currentUrl}`);
    const base64 = await QRCode.toDataURL(currentUrl, {
      margin: 0,
      width: 106
    });

    qrMapCode.attr('src', base64);

    let title = '';
    let background = '';

    if (SpotWall.isSpotWall) {
      // statement
      const spot = Gdata.CurrentSpots.dic[SpotWall.spot_id];
      title =
        (window.resolveTranslated && window.resolveTranslated(spot, 'title')) ||
        spot.title;
      background = window.parseImage(spot.images[0], 800);
    } else {
      const map = Gdata.CurrentMap.ori[0];
      title =
        (window.resolveTranslated && window.resolveTranslated(map, 'title')) ||
        map.title;
      background = window.parseImage(map.image_id, 1080);
    }

    qrMapImage.css('background', `url("${background}") no-repeat`);
    qrMapTitle.html(title);
  } catch (e) {
    console.log(e);
    console.log('error settings map qr');
  }
};
